import { render, staticRenderFns } from "./PhoenixLandingPage.vue?vue&type=template&id=69a3f450"
import script from "./PhoenixLandingPage.vue?vue&type=script&lang=js"
export * from "./PhoenixLandingPage.vue?vue&type=script&lang=js"
import style0 from "./PhoenixLandingPage.vue?vue&type=style&index=0&id=69a3f450&prod&module=%24s&lang=scss"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports